import {ReactNode} from 'react'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'
import {useConfig} from './ConfigProvider'

type Props = {
  children: ReactNode
}

export const RecaptchaProvider = ({children}: Props) => {
  const {recaptchaEnterpriseSiteKey} = useConfig()

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaEnterpriseSiteKey} useEnterprise>
      {children}
    </GoogleReCaptchaProvider>
  )
}
